import {SearchLinksShuffler} from './components/SearchLinksShuffler/SearchLinksShuffler.js';
import {SearchBox} from './components/SearchBox/SearchBox.js';
SearchBox()
SearchLinksShuffler()

